import { createContext, useContext, useEffect, useState } from 'react'

export const themes = [
  { id: 'pastel', label: 'Pastel' },
  { id: 'neon', label: 'Dark Neon' },
  { id: 'v3', label: 'v3 Refined' },
]

const STORAGE_KEY = 'magnitude-theme'
const DEFAULT_THEME = 'pastel'
const ThemeContext = createContext(null)

function readInitialTheme() {
  if (typeof window === 'undefined') return DEFAULT_THEME
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return themes.some((t) => t.id === stored) ? stored : DEFAULT_THEME
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitialTheme)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
    window.localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useTheme() {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider')
  return ctx
}
